<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        :width="iconFile.dimensions.width"
        :height="iconFile.dimensions.height"
        :viewBox="`0 0 ${iconFile.dimensions.width} ${iconFile.dimensions.height}`"
        :aria-label="ariaLabel || name"
        role="img"
        class="icon"
        v-html="iconFile.content"/>
</template>

<script>

import { camelCase, startCase } from 'lodash';
import icons from '../../assets/icons';
import unknown from '../../assets/icons/unknown.js';
import unknownCountries from '../../assets/icons/unknown-countries.js';
import unknownFinancial from '../../assets/icons/unknown-financial.js';

const transformName = (name) => startCase(camelCase(name)).replace(/ /g, '');

// TODO: merge icon and icon-frame in one component
/**
 * Icon
 *
 * @example
 * ```js
 * import { DsIcon } from '../../atoms';
 *
 * export default {
 *   components: { DsIcon },
 *   template: `<div>
 *
 *     <DsIcon name="icon-name-here" category="category-name-here"/>
 *
 *     <!-- icon with title for accessibility enhancement -->
 *     <DsIcon name="icon-name-here" category="category-name-here" title="icons description"/>
 *
 *   </div>`;
 * };
 *```
 */
export default {
    name: 'DsIcon',
    props: {
        name: {
            type: String,
            required: true
        },
        category: {
            type: String,
            required: true
        },
        ariaLabel: {
            type: String,
            default: ''
        }
    },
    computed: {
        iconFileUnknown () {
            switch (true) {
            case this.category === 'countries':
                return unknownCountries;
            case this.category === 'financial':
                return unknownFinancial;
            default:
                return unknown;
            }
        },
        iconFile () {
            return icons?.[transformName(this.category)]?.[transformName(this.name)] || this.iconFileUnknown;
        }
    },
    created () {
        this.$options.dimensions = { width: this.iconFile.dimensions.width, height: this.iconFile.dimensions.height };
    }
};
</script>
